export default __webpack_public_path__ + "static/media/eldorado.ed85e6fb.jpg";